// extracted by mini-css-extract-plugin
export default {"status":"FAz7KbOo89ucvnPeCPBN"};